/**
 * Mobile search slide-down panel
 */
(function () {
  const panel = document.querySelector('[data-snt-mobile-search-panel]');
  const backdrop = document.querySelector('[data-snt-mobile-search-backdrop]');
  const openBtn = document.querySelector('[data-snt-mobile-search-open]');
  if (!panel || !openBtn) return;

  const closeBtns = panel.querySelectorAll('[data-snt-mobile-search-close]');
  const mq = window.matchMedia('(max-width: 989px)');

  function isOpen() {
    return panel.classList.contains('is-open');
  }

  function openPanel() {
    panel.classList.add('is-open');
    backdrop && backdrop.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    const input = panel.querySelector('input[type="search"]');
    if (input) {
      window.setTimeout(function () {
        input.focus();
      }, 120);
    }
  }

  function closePanel() {
    panel.classList.remove('is-open');
    backdrop && backdrop.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    openBtn.focus();
  }

  openBtn.addEventListener('click', function (e) {
    if (!mq.matches) return;
    e.preventDefault();
    if (isOpen()) {
      closePanel();
    } else {
      openPanel();
    }
  });

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closePanel);
  });

  backdrop && backdrop.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) {
      closePanel();
    }
  });
})();
